import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import logo from "../../assets/logo.png"
import { useHistory } from "react-router";
import "./Navbar.scss"
import Button from "../Button/Button";
const Navbar = () => {
    // const companyDetails = useSelector((state) => state.companyData.company)
    //   const pages = useSelector((state) => state.companyData.pages)

    const [isScrolled, setIsScrolled] = useState(false);
    const history = useHistory()
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 0);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };

    }, []);
    const pages = [
        { Title: "Products", Slug: "/" },
        { Title: "Partners", Slug: "/" },
        { Title: "Pricing", Slug: "/" },
        { Title: "Solutions", Slug: "/" },
        { Title: "Resources", Slug: "/" },

    ]
    return (
        <div className="Witearn-navbar">
            <div className={`Witearn-navbar-fixed-header  ${isScrolled ? "scrolled" : ""}`}>
                <div className="Witearn-navbar-left">
                    <img alt="" className="logo-container"
                        onClick={() => {
                            history.push("/")
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth",
                            });
                        }}
                        src={logo} />
                </div>
                <div className="Witearn-navbar-center">
                    {pages.map((page, key) => {
                        return (
                            <div key={key} className="witearn-navbar-header-title" onClick={() => {
                                history.push(page.Slug)
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                            }}>
                                {page.Title}
                            </div>
                        )
                    })}
                </div>
                <div className="Witearn-navbar-right">
                    <Button isPrimary buttonText={"Get started"} />
                </div>
            </div>
        </div>
    )
}
export default Navbar